// 语言选择列表
import i18n from './i18n';

export default class I18nUtils {
    static langList = [
      { id: "en", name: "English" },
      { id: "zh", name: "简体中文" },
      { id: "zh_Hant", name: "繁体中文" },
      { id: "vi", name: "tiếng Việt" }
    ];

    static initLanguage(page) {
      let lang = page.$route.query.language || // 优先
                    page.$route.query.lang ||
                    localStorage.getItem("language");
        
      if (lang == null) {
        lang = window.navigator.language || (window.navigator.languages && window.navigator.languages[0]);
      }

      if (I18nUtils.langList.find(item => item.id === lang)) {
        I18nUtils.setLanguage(page, lang);
        return;
      }

      if (lang === 'zh-CN') lang = 'zh';
      if (lang !== "en" && lang !== "zh" && lang !== "he") lang = "zh"; // 默认为中文

      if (lang != null) {
        I18nUtils.setLanguage(page, lang);
        return;
      }
    }


    static setLanguage(page, lang) {
      // Vue 3 i18n: use i18n.global.locale instead of $i18n.locale
      i18n.global.locale = lang;
      localStorage.setItem("language", lang);
      I18nUtils.updateDivLanguage(lang);
    }

    static updateDivLanguage(lang) {
      if (lang !== 'zh') lang = 'en';
        
      const div = document.getElementById("i18n");
      if (div) div.className = lang;

      document.querySelectorAll(".i18n").forEach(ele => {
        ele.classList.remove('zh');
        ele.classList.remove('en');
        ele.classList.add(lang);
      })
    }
}
